<ts-dialog title="Edit View" (closeDialog)="dialogRef.close(false)">
  <form ts-dialog-body>
    <span class="flex flex-row items-center justify-between">
      <p>View Name</p>
      <ts-input
        class="w-1/2"
        placeholder="Enter view name..."
        [formControl]="viewNameForm"
        [roundedBorders]="false"
      ></ts-input>
    </span>
  </form>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="dialogRef.close(false)" [disabled]="viewNameForm.disabled"
      >Cancel</ts-button
    >
    <ts-button variant="primary" [loading]="loading()" [disabled]="disableSaveButton" (click)="onEditViewSave()"
      >Save
    </ts-button>
  </div>
</ts-dialog>
